<template>
	<div>
		<Header />
		<div class="section titles wf-section start">
			<div class="container w-container">
				<div class="heading-wrapper-center padding-bottom-small">
					<h2 class="heading-large">Boka en tjänst</h2>
					<h3 class="heading-medium">{{bookingTitle}}</h3>
				</div>
				<div class="tabs-menu plan w-tab-menu">
					<a v-if="previousok" class="button-tab rounded w-inline-block w-tab-link w--current"
						@click="previousDate()">
						<div class="nosel">&lt;</div>
					</a>
					<div class="button-tab rounded w-inline-block text-white">
						<div class="nosel">{{ date.toLocaleDateString('sv-SE', {
								weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'
							}).toUpperCase()
						}}</div>
					</div>
					<a v-if="nextok" class="button-tab rounded w-inline-block w-tab-link w--current" @click="nextDate()">
						<div class="nosel">&gt;</div>
					</a>
				</div>

				<div v-if="isOpenOnDate">
					<div class="w-layout-grid main-grid times">
						<div v-for="fixture in calendar" class="styleguide-color-wrapper">
							<div class="button w-inline-block fixtures nosel" @click="showBookingModal(fixture)"
								v-bind:class="{ 'booked': fixture.isBooked, '': !fixture.isBooked }">
								{{ fixture.hour }}:{{ ('0' + fixture.minutes).slice(-2) }}</div>
						</div>
					</div>
				</div>
				<div v-else>
					<br><br>
					<h1 class="subtitle has-text-danger">We are closed this day. Please pick another one in the calendar
					</h1>
				</div>

			</div>
		</div>
		<Footer />
	</div>
</template>
<script>
import { mapGetters, mapState, mapActions } from "vuex";
import schedule from "../config/schedule";
import Swal from 'sweetalert2'
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default {
	name: 'Book',
  	components: {
    	Header,
		Footer
  	},
	data() {
		let date = new Date();
		date.setHours(12, 0, 0);
		return {
			bookingType: this.$router.currentRoute.params.id,
			bookingTypes: ["wash","ceramic","tires"],
			bookingTitle: "",
			newBooking: {
				id: '',
				indexName: '',
				userId: '',
				userFirstName: '',
				company: {},
				email: '',
				car: {},
				fixture: {},
				services: {},
				date: {},
				bookingType: '',
				bookingTitle: ''
			},
			date: date,
			today: date,
			schedule: schedule.hours,
			previousok: false,
			nextok: true
		}
	},
	computed: {
		// map `this.user` to `this.$store.getters.user`
		...mapGetters([
			"user"
		]),
		...mapState('bookings', ['reservations']),
		...mapState('userdata', ['userdataextra']),
		isOpenOnDate() {
			return schedule.openingDays.includes(this.date.getDay());
		},
		calendar: function () {
			let calendar = [];
			this.schedule.forEach(hour => {
				let date = new Date(this.date.toDateString() + ' 12:00:00');
				date.setHours(hour.hour, hour.minutes, 0);

				if (date >= new Date()) {
					let reservation = this.reservations.filter(x => {
						return x.date.seconds === (date.getTime() / 1000)
					});
					// Different opening hours for Saturday & Sunday
					if(date.getDay() == 0 || date.getDay() == 6){
						if(hour.hour !== 8 && hour.hour !== 9){
							calendar.push({
								hour: hour.hour,
								minutes: hour.minutes,
								isBooked: reservation.length === 1
							});
						}
					}else{
						calendar.push({
							hour: hour.hour,
							minutes: hour.minutes,
							isBooked: reservation.length === 1
						});
					}
				}
			});
			return calendar;
		}
	},
	created() {
		this.$root.isLoading = true;
		this.getReservations();
		this.loadUserData();

		if(!this.bookingTypes.includes(this.bookingType)){		
			this.$router.replace({
				name: "Dashboard"
			}).catch(error => {
   				console.info(error.message)
			})
		}
		if(this.bookingType == "wash"){
			this.bookingTitle = "In-och utvändig tvätt";
		}else if(this.bookingType == "tires"){
			this.bookingTitle = "Däckbyte och hotell";
		}else if(this.bookingType == "ceramic"){
			this.bookingTitle = "Keramisk Ceramic Coat";
		}
	},
	methods: {
		...mapActions('bookings', ['create', 'getReservations']),
		...mapActions(['getUserData']),
		loadUserData: async function () {
			await this.getUserData();
			this.$root.isLoading = false;
		},
		showBookingModal: function (fixture) {
			let date = new Date(this.date.toDateString() + ' 12:00:00');
			date.setHours(fixture.hour, fixture.minutes, 0);
			this.newBooking = {
				indexName: this.user.extra.indexName,
				userId: this.user.extra.id,
				userFirstName: this.user.extra.details.firstName,
				company: this.user.extra.company,
				email: this.user.extra.email,
				car: this.user.extra.car,
				services: {},
				fixture: fixture,
				date: date,
				bookingType: this.bookingType,
				bookingTitle: this.bookingTitle
			};
			let datemodal = date.toLocaleString('sv-SE', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' }).toUpperCase()
			// if return this.newBooking.name.length > 0 && this.newBooking.phone.length
			if (fixture.isBooked) return;
			Swal.fire({
				title: "Bekräfta ny bokning",
				html: "Bokar tjänsten " + this.bookingTitle + "<br>" + datemodal,
				icon: "question",
				iconColor: "#ff0062",
				showCancelButton: !0,
				background: "#464646",
				color: "#ffffff",
				confirmButtonColor: "#6411ff",
				cancelButtonColor: "#ff0062",
				confirmButtonText: "Ja, forsätt!",
				cancelButtonText: "Nej, avboka!",
				buttonsStyling: true
			}).then((result) => {
				if (result.value) {
					this.doBooking();
				}
			});
		},
		doBooking: function () {
			this.$root.isLoading = true;
			//CREATE BOOKING
			this.create(this.newBooking).then(id => {
				this.$root.isLoading = false;
				this.$router.replace({
					name: "dashboard"
				});
				Swal.fire({
					title: "Din bokning är bekräftad!",
					text: "ID: " + id,
					icon: "success",
					showConfirmButton: false,
					background: "#464646",
					color: "#ffffff",
					timer: 2000
				});
			});
		},
		nextDate: function () {
			let newDate = new Date(this.date);
			newDate.setHours(12);
			newDate.setDate(newDate.getDate() + 1);
			this.date = newDate;
			this.previousok = true;

			let tenDaysDate = new Date(this.today);
			tenDaysDate.setHours(12);
			tenDaysDate.setDate(tenDaysDate.getDate() + 9);

			if (this.date > tenDaysDate) {
				// console.log("greater than 10");
				this.nextok = false;
			}
		},
		previousDate: function () {
			let newDate = new Date(this.date);
			newDate.setHours(12);
			newDate.setDate(newDate.getDate() - 1);
			this.date = newDate;
			if (this.date <= this.today) {
				this.previousok = false;
			} else {
				this.previousok = true;
			}
			this.nextok = true;
		}
	}
};
</script>
<style scoped>
.nosel {
  user-select: none!important;
  -moz-user-select: none!important;
  -webkit-user-select: none!important;
  -ms-user-select: none!important;
}
.main-grid.times {
	grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
}

@media screen and (max-width: 1024px) {
	.main-grid.times {
		grid-template-columns: 1fr 1fr 1fr 1fr;
	}
}

@media screen and (max-width: 767px) {
	.main-grid.times {
		grid-template-columns: 1fr 1fr;
	}
}

.w--current {
	background-color: #464646;
}

.w--current:hover {
	background-color: #6411ff;
}
.booked {
	background-color: #ff0062;
	cursor: not-allowed;
}
</style>